import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-loader-placeholder',
  templateUrl: './loader-placeholder.component.html',
  styleUrls: ['./loader-placeholder.component.scss']
})
export class LoaderPlaceholderComponent {

  @Input('data-type') dataType: 'professions-preview' | 'job-preview' = "professions-preview";
}
